<template lang="pug">
.navbar-container
  f7-navbar.popup-navbar
    f7-nav-left.nav-left
      f7-link.nav-icon(@click='$emit("close")')
    f7-nav-title {{ title }}
    f7-nav-right
    slot
</template>

<style lang="scss" scoped>
.navbar-container {
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 500;
  .popup-navbar {
    background: rgba(25, 39, 52, 0.9) !important;
    backdrop-filter: blur(10.8731px);
    &::after {
      background-color: rgba(0, 0, 0, 0) !important;
    }

    .nav-left {
      margin: 0 6px;
      .nav-icon {
        background-image: url('~@/assets/icons/close.png');
        background-repeat: no-repeat;
        background-size: 28px 28px;
        background-position: center;
      }
    }
  }
}
</style>

<script>
export default {
  props: {
    title: { type: String, require: true },
  },
}
</script>
